<script>
import FormTableComponentBaseKeyHelper
    from "./FormTableComponentBaseKeyHelper";
import {FORM_TABLE_OPTION} from "../../../constants/form-table-const";

const ALIGN = {
    left: {
        justifyContent: "flex-start",
    },
    center: {
        justifyContent: "center",
    },
    right: {
        justifyContent: "flex-end",
    },
}

export default {
    name: "FormTableComponentBase",
    mixins: [FormTableComponentBaseKeyHelper],
    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        align: {
            type: String,
            default: "center",
        },
        on: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        options() {
            return !this.optionsData || typeof this.optionsData !== "object" ? {} : this.optionsData;
        },

        tabindex() {
            return this.editable ? 5 : undefined;
        },

        styleObject() {
            return {
                ...(ALIGN[this.align] ? ALIGN[this.align] : ALIGN.center)
            }
        },
    }
}
</script>